import { writable } from 'svelte/store';
import { browser } from '$app/environment';
import {
  isPushSupported,
  getPermissionState,
  enablePush,
  disablePush,
  syncOnLoad
} from '$lib/services/push-notifications.js';

/**
 * Store per lo stato del toggle "Notifiche push" nel menu utente.
 * permission: 'unsupported' | 'default' | 'granted' | 'denied'
 */
function createPushStore() {
  const { subscribe, set, update } = writable({
    supported: false,
    permission: 'unsupported',
    enabled: false,
    loading: false,
    error: null
  });

  let initialized = false;

  return {
    subscribe,

    async init() {
      if (!browser || initialized) return;
      initialized = true;
      const supported = await isPushSupported();
      const permission = supported ? getPermissionState() : 'unsupported';
      set({
        supported,
        permission,
        enabled: permission === 'granted',
        loading: false,
        error: null
      });
      if (permission === 'granted') syncOnLoad();
    },

    async enable() {
      update((s) => ({ ...s, loading: true, error: null }));
      const res = await enablePush();
      if (!res.ok) console.error('[push] enable failed, reason:', res.reason);
      update((s) => ({
        ...s,
        loading: false,
        permission: getPermissionState(),
        enabled: res.ok,
        error: res.ok ? null : res.reason
      }));
    },

    async disable() {
      update((s) => ({ ...s, loading: true, error: null }));
      await disablePush();
      update((s) => ({ ...s, loading: false, enabled: false }));
    }
  };
}

export const pushStore = createPushStore();
